import type { EditorState } from '@atlaskit/editor-prosemirror/state';
import type { RemixHistoryEntryForUpdate } from '@atlassian/malleable-ui-components/types';

import { remixHistoryPluginKey } from './remix-history-plugin';

export function getHistoryEntryForUpdate({
	state,
	url,
	fieldId,
}: {
	fieldId?: string;
	state: EditorState;
	url?: string;
}): RemixHistoryEntryForUpdate | undefined {
	const remixHistoryState = remixHistoryPluginKey.getState(state);
	const historyMap = remixHistoryState?.historyMap;
	if (!historyMap) {
		return;
	}

	for (const historyEntry of Object.values(historyMap)) {
		const currentStackEntry = historyEntry.stack.find(
			(stackEntry) => (url && stackEntry.url === url) || (fieldId && stackEntry.fieldId === fieldId),
		);
		if (!currentStackEntry) {
			continue;
		}

		const historyEntryForUpdate: RemixHistoryEntryForUpdate = {
			conversationId: historyEntry.conversationId,
			dynamicUiSource: historyEntry.dynamicUiSource,
			latestFinalMessage: historyEntry.latestFinalMessage,
			dynamicUiType: currentStackEntry.dynamicUiType,
			dynamicUiSubtype: currentStackEntry.dynamicUiSubtype,
			finalMessage: currentStackEntry.finalMessage,
			fieldId: currentStackEntry.fieldId,
			url: currentStackEntry.url,
		};

		return historyEntryForUpdate;
	}
}
